<template>
  <div class="container-fluid background--light">
    <div class="container">
      <div class="section section--small">
        <div class="h2 h2--margin h2--primary">Podsumowanie zamówienia</div>
      </div>
      <ValidationObserver
        ref="observer"
        tag="form"
        @submit.prevent="goToPayments()"
        class="section section--margins row basket__section section--small"
      >
        <div class="col-2-3 basket__content">
          <div v-if="loading" class="basket__products">Trwa wczytywanie...</div>
          <div class="basket__products" v-else-if="cart && cart.items.length">
            <div class="table">
              <div class="table__head">
                <div class="table__row">
                  <div
                    class="table__column table__column--bold table__column--element"
                  >
                    Element
                  </div>
                  <div class="table__column">
                    <div class="table__row">
                      <div class="table__column table__column--bold">
                        Konfiguracja
                      </div>
                      <div
                        class="table__column table__column--quantity table__column--bold"
                      >
                        Ilość
                      </div>
                      <div
                        class="table__column table__column--price table__column--bold"
                      >
                        Cena
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table__body">
                <div
                  class="table__wrapper"
                  v-for="(item, index) in cart.items"
                  :key="index"
                >
                  <div class="table__row">
                    <div class="table__column table__column--element">
                      <div class="table__element">
                        <div class="table__label--mobile">Element:</div>
                        <div class="table__column--name table__column--bold">
                          {{ item.product.name }}
                        </div>
                      </div>
                    </div>
                    <div class="table__column">
                      <div class="table__row table__row--mb">
                        <div class="table__column">
                          <div class="table__label--mobile">Konfiguracja:</div>

                          <div class="table__configuration">
                            <div
                              class="d-table"
                              v-if="item.configuration.values"
                            >
                              <div
                                v-for="(field, key) in item.configuration
                                  .values"
                                :key="key"
                                class="d-table-row"
                              >
                                <div class="d-table-cell" v-if="field.label">
                                  {{ field.label }}:
                                </div>
                                <div
                                  v-if="
                                    field.label &&
                                    field.value &&
                                    field.value.firstValue
                                  "
                                  class="d-table-cell"
                                >
                                  {{ field.value.name }}
                                  ({{ field.value.firstValue }}x{{
                                    field.value.secondValue
                                  }}mm)
                                </div>
                                <div
                                  v-else-if="
                                    field.label &&
                                    field.value &&
                                    field.value.value
                                  "
                                  class="d-table-cell"
                                >
                                  {{ field.value.value }}
                                </div>
                                <div
                                  v-else-if="
                                    field.label &&
                                    field.value &&
                                    field.value.name
                                  "
                                  class="d-table-cell"
                                >
                                  {{ field.value.name }}
                                </div>
                                <div
                                  v-else-if="field.label"
                                  class="d-table-cell"
                                >
                                  {{ field.value }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="table__column table__column--quantity">
                          <div class="table__label--mobile">Ilość:</div>
                          <div>{{ item.quantity }}</div>
                        </div>
                        <div class="table__column table__column--price">
                          <div class="table__label--mobile">Cena:</div>
                          <div>
                            {{ formatCash(item.total) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table__anchors">
                    <span
                      class="link link__underline table__anchor"
                      @click="editProduct(item)"
                      >Edytuj</span
                    >
                    <span
                      class="link link__underline table__anchor"
                      :class="{ link__disabled: deleting }"
                      @click="deleteProductFromBasket(item)"
                      >Usuń</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="basket__products">Brak produktów</div>
          <router-link :to="{ name: 'Products' }" class="link"
            >Dodaj więcej produktów do zamówienia</router-link
          >
        </div>
        <BasketDelivery />
      </ValidationObserver>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/pages/order-payment-and-summary";
@import "@/assets/scss/components/table";
</style>

<style lang="scss">
@import "@/assets/scss/components/form/form";
</style>

<script>
import { ValidationObserver } from "vee-validate";
import { helperMixin } from "@/mixins/helpers.js";
import { mapActions, mapGetters } from "vuex";
import { getterTypes } from "@/store/modules/Cart/getter-types";
import { actionTypes } from "@/store/modules/Cart/action-types";
import { actionTypes as ProductsActionTypes } from "@/store/modules/Products/action-types";
import { actionTypes as addressActionTypes } from "@/store/modules/Address/action-types";
import { actionTypes as orderActionTypes } from "@/store/modules/Order/action-types";
import { validateMessages } from "@/config";

export default {
  name: "OrderSummary",
  metaInfo: {
    titleTemplate: "%s - Podsumowanie zamówienia",
  },
  mixins: [helperMixin],
  components: {
    BasketDelivery: () => import("@/pages/views/order/BasketDelivery"),
    ValidationObserver,
  },
  data() {
    return {
      deleting: false,
      loading: true,
    };
  },
  computed: {
    cart: {
      get() {
        return this.GET_CART();
      },
      set(value) {
        if (value.checkoutState === "shipping_selected") {
          this.FETCH_PAYMENT_METHODS();
        }
      },
    },
  },
  async created() {
    this.loading = true;
    const cart = await this.FETCH_CART();
    if (cart.checkoutState === "cart") {
      const data = await this.FETCH_ADDRESS();
      if (!data.length) {
        this.$notify({
          group: validateMessages.group,
          type: "error",
          title: validateMessages.error.header,
          text:
            "Brak uzupełnionych danych. Przejdź do profilu i uzupełnij adres.",
        });
        return false;
      }
      const billingAndShippingAddress = {
        shippingAddress: data[0],
        billingAddress: data[0],
      };
      await this.ADD_CHECKOUT_ADDRESS(billingAndShippingAddress);
      await this.FETCH_CART();
    }

    await this.FETCH_SHIPPING_METHODS();
    this.loading = false;
  },
  methods: {
    ...mapGetters("CartModule", [getterTypes.GET_CART]),
    ...mapActions("CartModule", [
      actionTypes.REMOVE_FROM_CART,
      actionTypes.FETCH_CART,
    ]),
    ...mapActions("OrderModule", [
      orderActionTypes.ADD_CHECKOUT_ADDRESS,
      orderActionTypes.ADD_SHIPPMENT_METHOD,
      orderActionTypes.FETCH_SHIPPING_METHODS,
    ]),
    ...mapActions("AddressModule", [addressActionTypes.FETCH_ADDRESS]),
    ...mapActions("ProductsModule", [
      ProductsActionTypes.SAVE_PRODUCT_CODE_CONFIG,
      ProductsActionTypes.DELETE_FILE_PRODUCT_CODE_CONFIG,
    ]),
    async editProduct(item) {
      const productCode = item.product.code;
      const configCode = item.configuration.code;

      this.$router.push({
        name: "Order",
        params: { productCode, configCode, itemId: item.id },
      });
    },
    async deleteProductFromBasket(item) {
      if (this.deleting) {
        return false;
      }
      this.deleting = true;
      await this.REMOVE_FROM_CART(item.id)
        .then(() => {
          this.$notify({
            group: validateMessages.group,
            type: "success",
            text: "Produkt został usunięty z koszyka.",
          });
        })
        .catch(() => {
          this.$notify({
            group: validateMessages.group,
            type: "error",
            text: "Wystąpił błąd podczas usuwanie produktu z koszyka.",
          });
        });
      this.deleting = false;
    },
    async goToPayments() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return;
      }

      this.$router.push({ name: "OrderPayment" });
    },
  },
};
</script>